import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

// init Masonry
function DOMContentLoaded() {
  // console.log("DOMContentLoaded");
  imagesLoaded(document.querySelector('.masonry'), function() {
    // console.log("imagesLoaded");

    var masonryElements = document.querySelectorAll('.masonry');

    masonryElements.forEach( element => {

      // init Masonry
      var msnry = new Masonry( element, {
        // options
        itemSelector: '.masonry-item',
        columnWidth:  '.masonry-item',
        gutter: '.gutter-sizer',
        percentPosition: true
      });

    })

    
  });
}

document.addEventListener('DOMContentLoaded', DOMContentLoaded);